import { formatCreditCardNumber, formatCreditCardExpiry } from '../../utils/formatters';
import { Row, Col } from '../grid';
import { Input, } from '../input';

export const MercadoPagoFields = () => {
  return (
    <>
      <Input
        name="creditCardNumber"
        format={formatCreditCardNumber}
        label="Número do cartão de crédito"
      />

      <Input
        name="creditCardHolderName"
        label="Nome impresso no cartão"
      />

      <Row>
        <Col>
          <Input
            name="creditCardExpiry"
            format={formatCreditCardExpiry}
            placeholder="MM / AA"
            label="Expiração"
          />
        </Col>

        <Col>
          <Input
            name="creditCardCvc"
            label="CVC"
          />
        </Col>
      </Row>
    </>
  )
}

export default MercadoPagoFields;
